import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Shield, Cloud, Landmark, GitBranch, Server, Settings, Bot, Box, Link as LinkIcon, Code } from 'lucide-react';
import { services } from '../data/mock';
import { useScrollScene } from './motion';
import ServiceCard from './ServiceCard';

const desktop = () => window.matchMedia('(min-width: 768px)').matches;

// Vertical scroll drives a horizontal reel on desktop; native swipe on mobile.
const ServicesSection = () => {
  const outer = useRef(null), track = useRef(null), bar = useRef(null);

  const measure = () => {
    if (!desktop()) { outer.current.style.height = ''; return 0; }
    const max = Math.max(0, track.current.scrollWidth - window.innerWidth);
    outer.current.style.height = `${max + window.innerHeight}px`;
    return max;
  };
  useEffect(() => { measure(); window.addEventListener('resize', measure); return () => window.removeEventListener('resize', measure); }, []);

  useScrollScene(outer, (p) => {
    const max = desktop() ? Math.max(0, track.current.scrollWidth - window.innerWidth) : 0;
    track.current.style.transform = max ? `translate3d(${-p * max}px,0,0)` : '';
    bar.current.style.transform = `scaleX(${p})`;
  });

  return (
    <section ref={outer} className="relative">
      <div className="md:sticky md:top-0 md:h-screen md:overflow-hidden flex flex-col justify-center py-7 md:py-0">
        <div ref={track} className="flex items-stretch gap-6 px-6 md:pl-[max(1.5rem,calc((100vw-72rem)/2+1.5rem))] md:pr-24 overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none will-change-transform" style={{ scrollbarWidth: 'none' }}>
          <div className="shrink-0 w-[80vw] md:w-[26rem] flex flex-col justify-center snap-start">
            <p className="font-mono-label text-[var(--muted)] flex items-center gap-3 mb-6"><span className="text-[var(--red)]">01</span><span className="w-10 h-px bg-[var(--line-strong)]" />What we do</p>
            <h2 className="font-display text-6xl leading-[0.95]">Capabilities, <em className="text-[var(--red)]">engineered</em> end to end.</h2>
            <p className="mt-6 text-[var(--muted)] text-lg">Keep scrolling. Ten disciplines, one accountable partner.</p>
            <Link to="/services" className="btn btn-ghost mt-8 self-start">All services</Link>
          </div>

          {services.map((s, i) => (
            <ServiceCard key={s.id} service={s} index={i} total={services.length} specs={4} className="shrink-0 w-[80vw] md:w-[24rem] snap-start" />
          ))}
        </div>
        <div className="hidden md:block absolute bottom-10 left-1/2 -translate-x-1/2 w-64 h-px bg-[var(--line-strong)]"><div ref={bar} className="h-full bg-[var(--red)] origin-left" style={{ transform: 'scaleX(0)' }} /></div>
      </div>
    </section>
  );
};

export default ServicesSection;
